import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { AppProvider } from './provider';
import './styles/index.css';

const container = document.getElementById('root');
if (!container) throw new Error('Root element not found');

createRoot(container).render(
    <StrictMode>
        <AppProvider />
    </StrictMode>
);
